import dayjs from 'dayjs';

import { COMMON_DATETIME_FORMAT } from 'constants/date';

export const getDateTimeFormat = date =>
  date ? dayjs(date).format(COMMON_DATETIME_FORMAT) : 'N/A';
